export default __webpack_public_path__ + "static/media/csc_05.eec37b49.png";